.stepDescription:global(.MuiTypography-root) {
	color: #5e5e5e;
	font-size: 0.9375rem;
	line-height: 1.6;
	font-weight: 400;
}

.configurationPage {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0.9375rem;
	justify-content: center;
	overflow: hidden;
}

.confirmationPage {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 0.625rem;
	padding-top: 0;
	gap: 0.625rem;
	box-sizing: border-box;
	align-items: flex-start;
}

.profileStep {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
	height: 100%;
	overflow: hidden;
	box-sizing: border-box;
}

.stepPaper {
	padding: 0 !important;
	width: 100%;
}

.modalTitle {
	padding: 0.5rem;
}

@media (max-width: 768px) {
	.profileStep {
		padding: 0.5rem;
	}

	.configurationPage {
		padding: 0.5rem;
	}
}
